import { z } from 'my-zod'
import { vehicleUseHistoryModel } from './vehicle-use-history-model'

export const vehicleCheckInView = vehicleUseHistoryModel.pick({
  id: true,
  lastModifiedDate: true,
  checkInDateTime: true,
  checkInTreadDepth32ndInches: true,
  checkInConditionNotes: true,
  checkInFormSnapshotUrl: true,
  checkInVehicleImages: true,
  checkInDidCustomerHitAnything: true,
  checkInDidVehicleHaveMechanicalOrElectricalIssue: true,
  customerMachineRanOk: true,
  checkInEngineHours: true,
  checkInMileage: true,
  checkInFuelLevel: true,
  checkInDamageReport: true,
  gearUsage: true,
  deletedDate: true
})

export type vehicleCheckInView = z.infer<typeof vehicleCheckInView>
